import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { AuditoriaContrato } from '../domain/auditoria-contrato.model';
import { AuditoriaDespesa } from '../domain/auditoria-despesa.model';

export class AuditoriaDespesaSerializer extends DomainSerializer<AuditoriaDespesa> {}
